import { useEffect, useState, useRef, forwardRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Grid,
  Icon,
} from "@mui/material";

import { Button, Form, Input } from "@gpstrackit/react-controls";

import { useIntl } from "react-intl";
import { NotificationManager } from "Components/Notifications";
import CustomCard from 'Components/Card';
import Alert from '@mui/material/Alert';

//Redux
import {
  devicesCommonGetDevices,
  clearRedux,
} from "Redux/actions";

import { HasPermission } from 'Core/security';


const ConfigurationFirstStep = forwardRef((props, ref) => {

  const dispatch = useDispatch();
  const { messages } = useIntl();

  const formRef = useRef(null);

  //states reduxers
  const devicesToRecibe = useSelector(state => state.devicesCommonRedux.devices);
  const loadingDevicesToRecibe = useSelector(state => state.devicesCommonRedux.loading);
  const user = useSelector(state => state.securityRedux.user);

  //loacal states
  let [deviceSearchCriteria, setDeviceSearchCriteria] = useState("");
  let [errorMessage, setErrorMessage] = useState(null);

  let [devices, setDevices] = useState(props.devices || []);
  let [applyScopes, setApplyScopes] = useState(props.applyScopes || ["Partial"]);
  const [applyScopesItems, setApplyScopesItems] = useState([
    { key: "Default", permissionKey: "vftcsd", msgKey: "vidfleet_configuration_apply_scopes_default" },
    { key: "All", permissionKey: "vftcsa", msgKey: "vidfleet_configuration_apply_scopes_all" },
    { key: "Partial", permissionKey: "vftcsp", msgKey: "vidfleet_configuration_apply_scopes_partial" }]);

  const onValidSubmit = () => {
    //se valida que los imei ingresados no existan 

    errorMessage = "";

    let deviceSearchCriteriaArr = deviceSearchCriteria.split(/[\s,;\t\n]+/);;

    if (deviceSearchCriteriaArr.length > 1) {
      let criterias = [];

      deviceSearchCriteriaArr.forEach(criteria => {
        let escCriteria = criteria.trim();

        let regx = /[^a-zA-Z0-9]/g;
        escCriteria = escCriteria.replace(regx, '');

        if (devices && devices.length) {
          for (let index in devices) {
            let device = devices[index];

            if (device.ESN != escCriteria) {
              criterias.push(escCriteria);
            }
          }
        } else {
          criterias.push(escCriteria);
        }
      });


      if (criterias.length) {
        dispatch(devicesCommonGetDevices(criterias));
        setDeviceSearchCriteria(criterias.join(" "))
      }
    } else {
      let isValid = true;

      for (let index in devices) {
        let device = devices[index];

        if (device.esn === deviceSearchCriteria) {
          isValid = false;
          errorMessage = messages["vidfleet_configuration_repetead_on_the_list"];
          break;
        }
      }

      if (isValid) {
        dispatch(devicesCommonGetDevices([deviceSearchCriteria]));

      }
    }

    setErrorMessage(errorMessage);
  }

  const removeDevice = (device) => {
    let devs = props.devices;
    let index = devs.indexOf(device);
    if (index > -1) {
      devs.splice(index, 1);
    }

    setDevices([...devs]);

    if (props.devicesChange) {
      props.devicesChange([...devs]);
    }
  }

  useEffect(() => {

    if (devicesToRecibe && devicesToRecibe.length > 0) {
      dispatch(clearRedux("DEVICES_COMMON"), { devices: [] });

      let deviceSearchCriteriaArr = deviceSearchCriteria.split(/[\s,;\t\n]+/);;
      let devs = props.devices;
      if (deviceSearchCriteriaArr.length > 1) {
        let incompleteDevice = false;

        if (devicesToRecibe.length === 0)
          errorMessage = "vidfleet_configuration_device_not_found";

        let devicesReceived = devicesToRecibe.filter(x => {
          return (deviceSearchCriteriaArr.includes(x.esn))
        })

        let deviceModel = devicesReceived[0].DeviceModel;
        devicesReceived.forEach(deviceReceived => {

          //repeated device
          var foundDevice = devs.find(x => {
            return x.esn === deviceReceived.esn
          })

          if (!foundDevice) {
            //no VidFleet and diferent model
            if (deviceReceived.manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase()) {
              errorMessage = "vidfleet_configuration_only_vidfleet_devices"
            } else if (deviceReceived.deviceModel.id !== deviceModel.id) {
              errorMessage = "vidfleet_configuration_only_vidfleet_devices"
            } else {
              devs.push(deviceReceived);
            }

          } else {
            errorMessage = "vidfleet_configuration_repetead_on_the_list"
          }

        });

        if (incompleteDevice)
          errorMessage = "vidfleet_configuration_incomplete_status"

        setDeviceSearchCriteria("");
        setErrorMessage(errorMessage);
        setDevices([...devs])
        if (props.devicesChange) {
          props.devicesChange(devs);
        }

      } else {

        errorMessage = "";
        //valid that has all valid devices
        let isValid = true;

        var device = devicesToRecibe.find(x => {
          return x.esn === deviceSearchCriteria
        })

        if (!device) {
          errorMessage = "vidfleet_configuration_device_not_found";
          isValid = false;
        } else {
          devs.forEach(d => {
            if (d.esn === device.esn) {
              errorMessage = "vidfleet_configuration_repetead_on_the_list"
              isValid = false;
            }
          });
        }

        //review if VidFleet is a VidFleet device
        if (device && device.deviceModel.manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase()) {
          isValid = false;
          errorMessage = "vidfleet_configuration_only_vidfleet"
        }

        //review if is the same device model
        let deviceModel = null;
        if (devs.length > 0)
          deviceModel = devs[0].deviceModel;

        if (devs.length > 0 && device && device.deviceModel.id !== deviceModel.id) {
          isValid = false;
          errorMessage = "vidfleet_configuration_only_same_model"
        }

        if (isValid) {
          devs.push(device);
          setDeviceSearchCriteria("");
          setDevices(devs);
          if (props.devicesChange) {
            props.devicesChange(devs);
          }

        } else {
          NotificationManager.error(
            messages["vidfleet_configuration_title"],
            messages[errorMessage],
            3000,
            null,
            null,
            'error'
          );
        }
      }

    }

  }, [devicesToRecibe])

  return (
    <Grid container>
      <Grid item xs={12}>
        <Form
          ref={formRef}
          onValidSubmit={onValidSubmit}
        >
          <Grid container>
            <Grid item xs={12}>
              {messages['vidfleet_configuration_apply_scopes']}
            </Grid>
            <Grid item xs={12}>
              {
                applyScopesItems.map((item, index) => {
                  if (HasPermission(user, item.permissionKey, "u"))
                    return (
                      <div className="d-sm-inline-block mb-1" key={`apply-scopes-${item.key}`} style={{ marginLeft: `${item.key !== "Default" ? "10px" : "0px"}` }}>
                        <div
                          onClick={e => {
                            let applyScps = applyScopes;
                            if (applyScps.includes(item.key)) {
                              applyScps.splice(applyScps.indexOf(item.key), 1);
                            } else if (item.key === "Partial") {
                              applyScps = ["Partial"];
                            } else {
                              if (applyScps.includes("Partial") && item.key != "Partial") {
                                applyScps.splice(applyScps.indexOf("Partial"), 1);
                              }
                              applyScps.push(item.key);
                            }
                            setApplyScopes([...applyScps]);
                            props.applyScopesChange([...applyScps]);
                          }}
                        >
                          {
                            props.getBadget(messages[item.msgKey], applyScopes.includes(item.key))
                          }
                        </div>
                      </div>
                    )
                })
              }

            </Grid>
            <Grid item xs={12} style={{ marginTop: 10 }}>
              {
                applyScopes.includes("Default") &&
                <Alert severity="error">
                  <span>{messages["vidfleet_configuration_apply_scopes_default_message"]}</span>
                </Alert>

              }
              {
                applyScopes.includes("All") &&
                <Alert style={{ marginTop: 3 }} severity="error">
                  <span>{messages["vidfleet_configuration_apply_scopes_all_message"]}</span>
                </Alert>

              }
              {
                applyScopes.includes("Partial") &&
                <Alert severity="info">
                  <span>{messages["vidfleet_configuration_apply_scopes_partial_message"]}</span>
                </Alert>
              }
            </Grid>
          </Grid>
          {
            applyScopes.includes("Partial") &&
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <Input
                  label={messages['vidfleet_configuration_search_criteria']}
                  value={deviceSearchCriteria || ''}
                  onChange={(value) => {
                    setDeviceSearchCriteria(value);
                    setErrorMessage("");
                  }}
                  required
                  requiredMessage={messages['common_field_required']}
                  noMargin
                  maxLength={500000}
                />

                {
                  errorMessage
                  &&
                  <span className="fg-danger fs-13">
                    {messages[errorMessage]}
                  </span>
                }
              </Grid>

              <Grid item xs={3} style={{ marginTop: 6, marginLeft: 10 }}>
                <br />
                <Button
                  size="lg"
                  className="btn btn-dark-blue"
                  disabled={loadingDevicesToRecibe}
                  onClick={() => {
                    if (deviceSearchCriteria !== "")
                      onValidSubmit();
                  }}
                >
                  {messages["vidfleet_configuration_add"]}
                </Button>
              </Grid>
            </Grid>
          }
        </Form>
      </Grid>
      <Grid item xs={12}>
        {
          applyScopes.includes("Partial") &&
            props?.devices?.length > 0 ? props.devices.map((item, index) => {
              return (
                <CustomCard
                  key={index}
                  onClick={() => {
                    let currentDevices = props.devices;
                    let selected = currentDevices.findIndex((device) => device.id === item.id);
                    if (selected > -1) currentDevices.splice(selected, 1);

                    setDevices([...currentDevices]);

                    if (props.devicesChange) {
                      props.devicesChange([...currentDevices]);
                    }
                  }}
                >
                  <div style={{ display: 'grid' }}>
                    <div>
                      <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['vidfleet_configuration_imei']}</label><span>{item.imei}</span>
                    </div>
                    <div>
                      <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['vidfleet_configuration_esn']}</label><span>{item.esn}</span>
                    </div>
                    <div>
                      <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['vidfleet_configuration_model']}</label><span>{item?.deviceModel?.name}</span>
                    </div>
                  </div>
                </CustomCard>
              )
            }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_devices_added']}</span></div>}
      </Grid>


    </Grid>
  )
});
export default ConfigurationFirstStep;
